<template>
  <div v-if="disable || success">
    <div class="loading-container" v-if="disable">
      <div v-if="disable">
        <div class="loading-content text-center">
          <img src="../assets/img/logo.png" class="bounce" />
        </div>
        <h5>Loading...</h5>
      </div>
    </div>
    <div v-if="success && message">
      <div class="loading-content text-center">
        <div class="alert alert-warning alert-dismissible fade show contact-fixed" role="alert">
          {{message}}
          <button type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true" style="position:relative; top:0;">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoaderGif",
  props: {
    message: String,
    disable: Boolean,
    success: Boolean
  }
};
</script>

<style>
.loaderGif {
  z-index: 40;
}

.loading-container {
  width: 100%;
  background: rgba(250, 250, 250, 0.9);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.bounce {
  width: 6em;
  height: 6em;
  margin: auto;
  border-radius: 50%;
  animation: bounce 1s infinite;
}

.loading-container h5 {
  font-size: 2em;
  color: #ee5214;
  margin: auto;
  width: 100%;
  left: 45%;
  right: 0;
  position: fixed;
  top: 75%;
}

.loading-content {
  position: fixed;
  top: 40%;
}

.loading-content span {
  position: fixed;
  top: 50%;
}

@keyframes bounce {
  0% {
    transform: translateY(6px);
  }
  5% {
    transform: translateY(8px);
  }
  10% {
    transform: translateY(12px);
  }
  15% {
    transform: translateY(20px);
  }
  20% {
    transform: translateY(38px);
  }
  25% {
    transform: translateY(72px);
  }
  30% {
    transform: translateY(100px);
  }
  35% {
    transform: translateY(152px);
  }
  40% {
    transform: translateY(154px) scale(1.1, 0.9);
  }
  50% {
    transform: translateY(176px) scale(1.4, 0.6);
  }
  55% {
    transform: translateY(162px) scale(1.2, 0.8);
  }
  60% {
    transform: translateY(138px) scale(1.05, 0.95);
  }
  65% {
    transform: translateY(110px);
  }
  70% {
    transform: translateY(72px);
  }
  75% {
    transform: translateY(38px);
  }
  80% {
    transform: translateY(20px);
  }
  85% {
    transform: translateY(12px);
  }
  90% {
    transform: translateY(8px);
  }
  95% {
    transform: translateY(5px);
  }
  100% {
    transform: translateY(5px);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/LoaderGif.vue